import appSettings from 'src/Ateam-BI/CorpReporting/app_settings'
import { WB_OPTIONS } from 'src/Ateam-BI/Frisco/Constants'

export const request = (request, onResponse) => {
    let corpReporingId = appSettings[request?.stage]['appId']
    if (request?.appId == corpReporingId) {
        onResponse({
            'allowWBSelection': true,
            'allowSupportingDocUpload': true,
            'requireCertificationCheck': true, 
            'hideLoadTable': true,
            'shouldShowErrorDisclaimer': true
        })

    } else {
        onResponse({  })
    }
}

export const disabled = (request, onResponse) => {
    let corpReporingId = appSettings[request?.stage]['appId']
    if (request?.appId == corpReporingId) {
        onResponse({
            'disabled': (request?.info?.custom_attributes?.find(attr => attr.attribute_type === "DISABLED")?.attribute || "false") === "true",
            'annualOnly': (request?.info?.custom_attributes?.find(attr => attr.attribute_type === "CADENCE")?.attribute || "") === "ANNUALLY"
        })

    } else {
        onResponse({  })
    }
}

export const getFilteredWbOptions = (processData) => {
    if (!processData?.custom_attributes) {
        return [WB_OPTIONS.PRE_WB];
    }

    const noPreWbAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_PRE_WB_DUE_DATE"
    );
    
    const noPostWbAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_POST_WB_DUE_DATE"
    );

    const noPostTaxAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "NO_POST_TAX_DATE"
    );

    const postTaxDateAttribute = processData.custom_attributes.find(
        attr => attr.sub_type === "FRISCO" && attr.attribute_type === "POST_TAX_DATE"
    );

    const preWbEnabled = noPreWbAttribute?.attribute !== "true";
    const postWbEnabled = noPostWbAttribute?.attribute !== "true";
    const postTaxEnabled = noPostTaxAttribute?.attribute === "false" && postTaxDateAttribute?.attribute && postTaxDateAttribute?.attribute !== "NaN";

    let filteredOptions = [];

    // if pre wb is true: push pre wb 
    if (preWbEnabled) {
        filteredOptions.push(WB_OPTIONS.PRE_WB);
    }

    // if post wb is true
    if (postWbEnabled) {
        filteredOptions.push(WB_OPTIONS.POST_WB);
        // and if pre wb is true and environment is Transfer_FAST_RedShift : push no post wb
        if (preWbEnabled && processData.environment === "Transfer_FAST_RedShift") {
                filteredOptions.push(WB_OPTIONS.NO_POST_WB);
        }
    }

    // if post tax is enabled, push Pre-WB Post Tax and remove pre wb
    // ^"and remove pre wb" - this is not happening currently. should it be?
    if (postTaxEnabled) {
        filteredOptions.push(WB_OPTIONS.PRE_WB_POST_TAX);
    } 

    return filteredOptions;
}

export const getProcessNameMaxLength = (appId, stage) => {
    const corpReportingId = appSettings[stage]?.appId;
    // 10 being the limit for process name field for corporate reporting friscos
    return appId == corpReportingId ? 10 : null;
}



